import React from 'react';
import {
  Edit,
  SimpleForm,
  TextInput,
} from 'react-admin';

const UserEdit = props => (
  <Edit {...props}>
    <SimpleForm>
      <TextInput source="display_name" />
    </SimpleForm>
  </Edit>
);

export default UserEdit;
